import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import { getContrastTextColor } from '../utils/ColorUtils';

const LeadEventsRow = ({ registries }) => {
    const [orderBy, setOrderBy] = useState('creationTimestamp');
    const [orderDesc, setOrderDesc] = useState(true);
    
    const handleSort = (column) => {
        if (orderBy === column) {
            setOrderDesc(!orderDesc);
        } else {
            setOrderBy(column);
            setOrderDesc(false);
        }
    };
    
    const getSortIcon = (column) => {
        if (orderBy !== column) return '↕️';
        return orderDesc ? '↓' : '↑';
    };
    
    if (!registries || registries.length === 0) {
        return (
            <div className="text-center p-4 text-muted" data-testid="no-events-message">
                <p>No hay registros para este lead.</p>
            </div>
        );
    }
    
    const sortedRegistries = [...registries].sort((a, b) => {
        let aValue = a[orderBy];
        let bValue = b[orderBy];
        
        if (orderBy === 'registryType') {
            aValue = a.registryType?.name || '';
            bValue = b.registryType?.name || '';
        } else if (orderBy === 'subStatus') {
            aValue = a.subStatus?.name || '';
            bValue = b.subStatus?.name || '';
        } else if (orderBy === 'salesRep') {
            aValue = a.salesRep?.name || '';
            bValue = b.salesRep?.name || '';
        }
        
        if (aValue < bValue) return orderDesc ? 1 : -1;
        if (aValue > bValue) return orderDesc ? -1 : 1;
        return 0;
    });

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatDateOnly = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    return (
        <Table striped hover responsive data-testid="events-table">
            <thead className="table-dark">
                <tr>
                    <th 
                        onClick={() => handleSort('creationTimestamp')} 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Fecha {getSortIcon('creationTimestamp')}
                    </th>
                    <th 
                        onClick={() => handleSort('registryType')} 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Tipo {getSortIcon('registryType')}
                    </th>
                    <th 
                        onClick={() => handleSort('subStatus')} 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Detalle de Estado {getSortIcon('subStatus')}
                    </th>
                    <th 
                        onClick={() => handleSort('salesRep')} 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Comercial {getSortIcon('salesRep')}
                    </th>
                    <th 
                        onClick={() => handleSort('comments')} 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Comentarios {getSortIcon('comments')}
                    </th>
                    <th 
                        onClick={() => handleSort('followUpDate')} 
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                        Próximo Seguimiento {getSortIcon('followUpDate')}
                    </th>
                </tr>
            </thead>
            <tbody>
                {sortedRegistries.map((registry, index) => (
                    <tr key={registry.id || index}>
                        <td>{formatDate(registry.creationTimestamp)}</td>
                        <td>
                            {(() => {
                                const getStatusColor = (statusId) => {
                                    const colors = {
                                        1: '#ffc107', 2: '#17a2b8', 3: '#28a745', 4: '#dc3545'
                                    };
                                    return colors[statusId] || '#6c757d';
                                };
                                
                                const color = getStatusColor(registry.registryType?.valueId);
                                return (
                                    <span 
                                        className="badge" 
                                        style={{ 
                                            backgroundColor: color, 
                                            color: getContrastTextColor(color) 
                                        }}
                                    >
                                        {registry.registryType?.name || 'Sin especificar'}
                                    </span>
                                );
                            })()
                            }
                        </td>
                        <td>
                            {registry.subStatus?.name ? (
                                <span className="badge bg-secondary">
                                    {registry.subStatus.name}
                                </span>
                            ) : '-'}
                        </td>
                        <td>{registry.salesRep?.name || '-'}</td>
                        <td>
                            {registry.comments ? (
                                <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {(() => {
                                        const comment = registry.comments;
                                        const isOrderCreated = comment.includes('Pedido creado - ID:') && registry.registryType?.valueId === 8;
                                        
                                        if (isOrderCreated) {
                                            const orderIdMatch = comment.match(/ID: (\d+)/);
                                            if (orderIdMatch) {
                                                const orderId = orderIdMatch[1];
                                                return (
                                                    <>
                                                        Pedido creado - 
                                                        <a 
                                                            href={`/orders/${orderId}`} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={{ color: '#007bff', textDecoration: 'underline' }}
                                                        >
                                                            ID: {orderId}
                                                        </a>
                                                    </>
                                                );
                                            }
                                        }
                                        return comment;
                                    })()
                                    }
                                </div>
                            ) : '-'}
                        </td>
                        <td>{formatDateOnly(registry.followUpDate)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default LeadEventsRow;